import config from 'app/config';
import moment from 'moment';
/**
 * Следующее значение last_motion_galileosky_date при live blackbox (клиент).
 * Та же политика, что app/utils/motionGalileoskyDate.js.
 */
export function resolveNextMotionGalileoskyDate(params) {
    const { canSpeed, candidateDatetime, currentDatetime, speedThreshold = config.motionSpeedThreshold, skewMs = config.motionDatetimeSkewMs, nowMs = Date.now(), candidateParse = 'utc', currentParse = 'local' } = params;
    const speed = Number(canSpeed);
    if (!Number.isFinite(speed) || speed <= speedThreshold) {
        return normalizeDatetime(currentDatetime);
    }
    const candidateMs = parseMotionDatetimeMs(candidateDatetime, candidateParse);
    if (candidateMs == null) {
        return normalizeDatetime(currentDatetime);
    }
    const maxAllowedMs = nowMs + skewMs;
    if (candidateMs > maxAllowedMs) {
        return normalizeDatetime(currentDatetime);
    }
    if (currentDatetime == null || currentDatetime === '') {
        return formatAcceptedCandidate(candidateDatetime, candidateParse);
    }
    const currentMs = parseMotionDatetimeMs(currentDatetime, currentParse);
    if (currentMs == null || currentMs > maxAllowedMs || candidateMs > currentMs) {
        return formatAcceptedCandidate(candidateDatetime, candidateParse);
    }
    return normalizeDatetime(currentDatetime);
}
function parseMotionDatetimeMs(value, parseMode) {
    if (value == null || value === '') {
        return null;
    }
    const parsed = parseMode === 'local' ? moment(value) : moment.utc(value);
    const ms = parsed.valueOf();
    return Number.isFinite(ms) ? ms : null;
}
function formatAcceptedCandidate(value, parseMode) {
    if (value == null || value === '') {
        return null;
    }
    const parsed = parseMode === 'local' ? moment(value) : moment.utc(value);
    if (!parsed.isValid()) {
        return null;
    }
    // В Redux даты conditions — локальные строки, как у соседних полей blackbox.
    return parsed.local().format('YYYY-MM-DD HH:mm:ss');
}
function normalizeDatetime(value) {
    if (value == null || value === '') {
        return null;
    }
    return typeof value === 'string' ? value : moment(value).format('YYYY-MM-DD HH:mm:ss');
}
